export function colToLetter(col: number): string {
  let letter = ''
  let n = col
  while (n > 0) {
    n--
    letter = String.fromCharCode(65 + (n % 26)) + letter
    n = Math.floor(n / 26)
  }
  return letter
}
